import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PersonIcon from '@mui/icons-material/Person';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { Divider } from '@mui/material';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

const menuItemStyle = {
    fontSize: 14,
    textTransform: "uppercase"
}
const menuIconStyle = {
    fontSize: 15,
    marginRight: "5px"
}
export default function HeaderDropdown() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const navigate = useNavigate()
    const handleClose = (e) => {
        setAnchorEl(null);
        if (e.target.value === 2) {
            navigate('/changepassword')
        }
        if (e.target.value === 1) {
            navigate('/profile')
        }
    };
    const handleLogout = () => {
        sessionStorage.removeItem('user');
        window.location.reload();
    }
    return (
        <>
            <Button
                id="basic-button"
                onClick={(e) => handleClick(e)}
            >
                <AccountCircleIcon sx={{ fontSize: 30, color: '#fff' }} />
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <>
                    <MenuItem sx={menuItemStyle} onClick={(e) => handleClose(e)} value={'1'}>
                        <PersonIcon sx={menuIconStyle} />PROFILE</MenuItem>
                    <Divider />
                </>
                <MenuItem sx={menuItemStyle} onClick={handleLogout}>
                    <PowerSettingsNewIcon sx={menuIconStyle} />
                    LOGOUT
                </MenuItem>
            </Menu>
        </>
    );
}